import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-850ed452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-statement modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Candidate ", -1))
const _hoisted_6 = { class: "modal-statement modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Select Certificates You Are Uploading ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-evidence-upload modal-content" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Upload Evidence")
], -1))
const _hoisted_9 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_10 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_11 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg tw-border-[rgba(0,0,0,0.4)] tw-border-[1px] tw-border-dashed !tw-mb-4" }
const _hoisted_12 = {
  key: 0,
  class: "attachment-list !tw-mt-0"
}
const _hoisted_13 = { class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none" }
const _hoisted_14 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_15 = { class: "modal-footer" }

import { ref, onMounted, computed } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";
import InputField from "@/core/components/common/InputField.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseCertificateUploadModal',
  props: {
  eligibility: {
    type: Object,
    default: null,
  },
  candidate: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-submit"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const eligibilityItems = ref([]) as any;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);
const user = computed(() => store.getters[`${USER_STORE}/user`]);

const validation = ref({
  candidate: [(v: string) => !!v || "Candidate name required"],
  attachments: [
    (v: any[]) => v.length > 0 || "At least one attachment is required",
  ],
});

const candidateName = ref<string>("");

const selectedDocument = ref(null);
const selectedCertificateId = ref(null);

const onFileChange = async (event: any) => {
  const file = event.target.files[0];
  if (file) {
    try {
      isUploadImg.value = true;
      selectedDocument.value = file;
      const formData = new FormData();
      formData.append("file", file);
      const uploadedFile = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );
      selectedDocument.value = uploadedFile;
      displayToastMessage(
        internalInstance,
        "Document added successfully",
        "success"
      );
    } catch (error: any) {
      displayToastMessage(internalInstance, error.message, "error");
    } finally {
      event.target.value = "";
      isUploadImg.value = false;
    }
  }
};

const setEligibilityData = () => {
  if (props.eligibility.data.length) {
    props?.eligibility?.data.forEach((eligibility: any) => {
      eligibilityItems.value.push(eligibility);
    });
  }
};

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid) return;
  let certificateData = {
    userId: user.value.id,
    certificateId: selectedCertificateId.value,
    metadata: {
      url: null,
      registrationNumber: null,
    },
    attachments: [selectedDocument.value],
  };

  try {
    isUploadImg.value = true;
    await store.dispatch(`${USER_STORE}/addNewCertificate`, certificateData);
  } catch (error: any) {
    displayToastMessage(internalInstance, error.message, "error");
  } finally {
    isUploadImg.value = false;
    emits("on-close");
  }
};

// const removeAttachment = (index: number) => {
//   selectedDocument.value.splice(index, 1);
// };
const removeAttachment = () => {
  selectedDocument.value = null;
};

const onClickBackButton = () => {
  return emits("on-close");
};

onMounted(() => {
  setEligibilityData();
  if (props.candidate) {
    candidateName.value = props.candidate.userName;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onClickBackButton,
    maxWidth: "588px",
    width: "100%",
    borderRadius: "20px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Certificate Upload",
    headerDescription: "Please upload the certificates to meet the entry requirements.",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: candidateName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((candidateName).value = $event)),
                    rules: validation.value.candidate,
                    placeholder: "Candidate name here",
                    disabled: true
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_v_select, {
                    items: eligibilityItems.value,
                    "item-title": "name",
                    "item-value": "id",
                    modelValue: selectedCertificateId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCertificateId).value = $event)),
                    class: "input_field custom-select",
                    density: "compact",
                    placeholder: "e.g Plumbing & Heating",
                    "center-affix": true,
                    "single-line": true,
                    "menu-props": { contentClass: 'c_select__dropdown' },
                    variant: "outlined",
                    clearable: "",
                    menu: ""
                  }, null, 8, ["items", "modelValue"])
                ]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                        'added-img': selectedDocument.value,
                      }]),
                        label: "Drag and drop images & files, or Browse",
                        variant: "solo-filled",
                        modelValue: selectedDocument.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDocument).value = $event)),
                        rules: validation.value.attachments,
                        onChange: onFileChange,
                        "prepend-icon": "mdi-file-image-box"
                      }, null, 8, ["modelValue", "rules", "class"])
                    ])
                  ]),
                  (selectedDocument.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (selectedDocument.value?.mime === 'application/pdf')
                              ? (_openBlock(), _createBlock(PdfIcon, {
                                  key: 0,
                                  class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                }))
                              : (_openBlock(), _createBlock(ImageIcon, {
                                  key: 1,
                                  class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                })),
                            _createVNode(Text, {
                              variant: "p",
                              textWeight: "400"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedDocument.value?.name || selectedDocument.value?.originalName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_v_icon, {
                            class: "cursor-pointer !tw-text-[16px]",
                            icon: "mdi-close",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (removeAttachment()))
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Submit ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})